import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function CancelModal({
  isOpen,
  onClose,
  onConfirm,
  appointmentId,
  item,
  loader,
  heading = "Appointment",
  showAppId = true,
}) {
  const methods = useForm();
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = methods;

  useEffect(() => {
    methods.reset({ cancel_reason: "" });
  }, [isOpen]);


  useEffect(() => {
    setValue("cancel_reason", item?.appointment_details?.reason || "");
  }, [item, isOpen]);


  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
        <form
          action=""
          onSubmit={handleSubmit((data) => onConfirm(data, "cancel"))}
        >
          <ModalHeader className="header_modal align-items-center">
            <h5 className="modal-title_u">Cancel {heading}</h5>
          </ModalHeader>
          <ModalBody className="modal_form_body">
            <div
              style={{
                backgroundColor: "#F2F2F2",
                padding: "10px",
                borderRadius: "8px",
              }}
              className="min-height-auto"
            >
              {showAppId && <h2>Appointment ID: {appointmentId}</h2>}
              {/* Reason */}
              <div className="row-primary">
                <h2>Reason *</h2>
                <Controller
                  name="cancel_reason"
                  control={control}
                  rules={{
                    required: "Please write reason",
                  }}
                  render={({ field }) => (
                    <>
                      <textarea
                        className="type_inp input-in"
                        {...field}
                        placeholder="Write reason for Cancel ..."
                        required
                      ></textarea>

                      {errors?.cancel_reason?.message && (
                        <ErrorMessage text={errors?.cancel_reason?.message} />
                      )}
                    </>
                  )}
                />

              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <SubmitButton
              buttonType="submit"
              loader={loader}
              className={"tomatoRed"}
              btnText="Cancel"
            />
            <button className="Cancle_button" type="button" onClick={onClose}>
              Close
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default CancelModal;
